import { Button, Paper, Typography } from "@mui/material";
// import { auto } from "@popperjs/core";


function OktaLogin() {
    // const navigate = useNavigate();
    const  login = () =>{
        // Redirect to backend OIDC login endpoint
        // The backend will handle the Okta OAuth flow
        window.location.href = "/login";
    }

    return (
        <Paper
            elevation={3}
            sx={{
                padding: 4,
                margin: 'auto', 
                position: 'absolute', 
                top: '40%',
                left: '50%', 
                transform: 'translate(-50%, -50%)', 
                width: '100%', 
                maxWidth: 400, 
                height: '50%', 
                maxHeight: 200, // Optional: Limit height if needed
                textAlign: 'center', // Center text inside the Paper
            }}
            >
            <Typography component="h1" variant="h5" align="center">
                App Manager Login
            </Typography>
            <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ backgroundColor: '#181818', width:'50%' }}
                onClick={() => login()}>
                    Login with Okta
            </Button>
        </Paper>
    )
}

export default OktaLogin;